export default "__VITE_ASSET__BizAtXxK__"